import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { registerTemplateKeys } from '../registerTemplateKeys'
import {
  RegisterTemplate,
  IRegisterTemplate,
} from '@core/entities/register/RegisterTemplate'

const templateTransform = (response: IRegisterTemplate) =>
  RegisterTemplate.new(response)

export const useGetRegisterTemplate = (
  payload: RequestTypes['getRegisterTemplate'],
  options?: UseQueryOptions<IRegisterTemplate, string, RegisterTemplate>,
) => {
  const registerTemplateQuery = registerTemplateKeys
    .byOrganisation(payload)
    ._ctx.byTemplateId(payload)

  return useQuery({
    select: templateTransform,
    ...registerTemplateQuery,
    ...options,
  })
}
